import { type FC, useContext } from "react";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../../Forms/DragDrop/DragDropTypes";
import { isHeadingValue } from "../ReceiptHeadingComponent";

export const ReceiptHeadingSettings: FC<DragDropSettingsProps> = ({
    id,
    value,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    let completed = "";
    let parked = "";

    if(isHeadingValue(value)) {
        completed = value.completed;
        parked = value.parked;
    }

    return (
        <>
            <label className="block">
                Completed Sale
                <input
                    type="text"
                    name="completed"
                    value={completed}
                    onChange={e => {
                        manager.updateComponent(id, {
                            completed: e.currentTarget.value,
                            parked,
                        });
                    }}
                    placeholder="Tax Invoice"
                />
            </label>
            <label className="block">
                Parked Sale
                <input
                    type="text"
                    name="parked"
                    value={parked}
                    onChange={e => {
                        manager.updateComponent(id, {
                            completed,
                            parked: e.currentTarget.value,
                        });
                    }}
                    placeholder="Held Sale"
                />
            </label>
        </>
    );
};
